export const navLinks = [
	{ navLinkId: 'Home', scrollToId: 'homeContainer' },
	{ navLinkId: 'About', scrollToId: 'aboutContainer' },
	{ navLinkId: 'Skills', scrollToId: 'skillsContainer'},
	{ navLinkId: 'Media', scrollToId: 'mediaContainer' },
	{ navLinkId: 'Contact', scrollToId: 'contactContainer' },
];
